function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#2495bc;}.cls-1{opacity:0.7;}.cls-3{fill:#27aae1;opacity:0.65;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Cogo logo_samo ikona");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M329.69,461.9a12,12,0,0,0-16.57,3.34c-4.53,6.81-2.26,22.73-2.16,23.41a1.08,1.08,0,0,0,1.33.89c0.66-.17,16.21-4.25,20.74-11.06A12,12,0,0,0,329.69,461.9Z",
  transform: "translate(-288.89 -447.82)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M290.88,478.47c4.53,6.81,20.08,10.89,20.74,11.06a1.08,1.08,0,0,0,1.33-.89c0.1-.67,2.36-16.59-2.16-23.41A12,12,0,0,0,290.88,478.47Z",
  transform: "translate(-288.89 -447.82)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M312,447.82a12,12,0,0,0-12,12c0,8.18,10.7,20.19,11.15,20.69a1.08,1.08,0,0,0,1.6,0c0.46-.51,11.15-12.51,11.15-20.69A12,12,0,0,0,312,447.82Z",
  transform: "translate(-288.89 -447.82)"
});

var SvgCogoIconLogin = function SvgCogoIconLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 46.14 41.74",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCogoIconLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cogo_icon_login.1834c201.svg";
export { ForwardRef as ReactComponent };